import React from "react";
import { Modal } from "antd";

const LogoutConformation = ({
    isVisible,
    onCancel,
    onConfirm,
    message = "Are you sure you want to logout?",
}) =>{
    return(
        <Modal
      title="Logout"
      visible={isVisible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Logout"
      cancelText="Cancel"
    >
      <p>{message}</p>
    </Modal>
    )

}

export default LogoutConformation;